import React from "react";

import { VacationsTheme } from "@swa-ui/design-tokens";
import { usePlacement } from "@swa-ui/placements";
import { classNames } from "@swa-ui/string";

import { ALGTransitionBannerPlacement } from "../ALGTransitionBannerPlacement";
import { ManageMyVacationsForm } from "../ManageMyVacationsForm/ManageMyVacationsForm";
import styles from "./ManageMyVacationsFlyout.module.scss";

export const ManageMyVacationsFlyout = () => {
  const { placement: algTransitionBanner } = usePlacement("algTransitionBanner");

  return (
    <VacationsTheme>
      <div className={getFlyoutClasses()}>
        {algTransitionBanner && (
          <ALGTransitionBannerPlacement {...algTransitionBanner} mobileView />
        )}
        <div className={styles.manageMyVacationsForm}>
          <ManageMyVacationsForm />
        </div>
      </div>
    </VacationsTheme>
  );

  function getFlyoutClasses() {
    return classNames({
      [styles.manageMyVacationsFlyout]: true,
      [styles.withALGTransitionBanner]: algTransitionBanner,
    });
  }
};
